module.exports = __webpack_public_path__ + "media/fonts/lineto-circular-medium-8f516c4c.eot";